module.exports = __webpack_public_path__ + "static/img/815_phase_function_Paper_Points.bc2683a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/815_phase_function_Paper_Points.png
// module id = OcSl
// module chunks = 0